import { render, staticRenderFns } from "./ReportQC.vue?vue&type=template&id=afdc1efa&"
import script from "./ReportQC.vue?vue&type=script&lang=js&"
export * from "./ReportQC.vue?vue&type=script&lang=js&"
import style0 from "./ReportQC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports